import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=20c6314a&scoped=true&"
import script from "./Basic.vue?vue&type=script&lang=js&"
export * from "./Basic.vue?vue&type=script&lang=js&"
import style0 from "./Basic.vue?vue&type=style&index=0&id=20c6314a&prod&lang=scss&scoped=true&"
import style1 from "./Basic.vue?vue&type=style&index=1&id=20c6314a&prod&lang=scss&"
import style2 from "./Basic.vue?vue&type=style&index=2&id=20c6314a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6314a",
  null
  
)

export default component.exports